import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight, Calendar, Tag } from 'lucide-react';
import { getPosts } from '../api/client';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';
import SEOHead from '../components/SEOHead';

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPosts().then(d => { setPosts(d); setLoading(false); }).catch(() => setLoading(false));
    window.scrollTo(0, 0);
  }, []);

  const formatDate = (d) => {
    if (!d) return '';
    return new Date(d).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  const readTime = (content) => {
    if (!content) return '2 menit';
    const words = content.split(' ').length;
    return `${Math.max(1, Math.ceil(words / 200))} menit`;
  };

  return (
    <div style={{ background: 'var(--bg)', minHeight: '100vh', cursor: 'none' }}>
      <SEOHead
        title="Blog & Artikel IT"
        description="Tips, tutorial, dan artikel seputar IT dari Erwin Paisal. Jaringan komputer, hardware, software, MikroTik, dan teknologi terkini."
        keywords="blog IT Medan, tips MikroTik, tutorial jaringan komputer, tips IT Indonesia, artikel teknologi"
        url="/blog"
      />
      <Navbar />
      <div style={{ maxWidth: 1280, margin: '0 auto', padding: '120px 32px 80px' }}>

        {/* Header */}
        <div style={{ marginBottom: 64 }}>
          <Link to='/' style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontFamily: "'DM Mono', monospace", fontSize: 11, color: '#6a6a88', textDecoration: 'none', letterSpacing: 1, marginBottom: 32, transition: 'color 0.2s' }}
            onMouseEnter={e => e.currentTarget.style.color = '#f2f2ff'}
            onMouseLeave={e => e.currentTarget.style.color = '#6a6a88'}>
            <ArrowLeft size={13} /> KEMBALI
          </Link>
          <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 12, color: '#6a6a88', letterSpacing: 3, marginBottom: 12 }}>BLOG</div>
          <h1 style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 'clamp(36px,7vw,80px)', fontWeight: 700, color: '#f2f2ff', margin: 0, letterSpacing: '-2px', lineHeight: 1 }}>
            Tips &amp;<br />
            <span style={{ background: 'linear-gradient(135deg,#00e5ff,#9b00ff,#ff0099,#ffb700,#00e5ff)', backgroundSize: '400% 400%', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text', animation: 'holo-shift 5s ease infinite' }}>Artikel IT</span>
          </h1>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: 80, color: '#6a6a88', fontFamily: "'DM Mono', monospace", fontSize: 13 }}>MEMUAT ARTIKEL...</div>
        ) : posts.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 80, color: '#6a6a88', fontFamily: "'DM Mono', monospace", fontSize: 13 }}>BELUM ADA ARTIKEL DITERBITKAN.</div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 24 }} className='port-grid'>
            {posts.map((post, i) => (
              <Link key={post.id} to={`/blog/${post.slug}`}
                style={{ textDecoration: 'none', animation: `fadeUp 0.6s ease ${i*0.1}s both` }}>
                <div style={{
                  background: 'var(--card)',
                  border: '1px solid rgba(255,255,255,0.07)',
                  borderRadius: 4, overflow: 'hidden',
                  transition: 'border-color 0.2s, transform 0.2s, box-shadow 0.2s',
                  height: '100%',
                }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(0,229,255,0.25)'; e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.3)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.07)'; e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none'; }}
                >
                  {post.cover_image && (
                    <div style={{ height: 180, overflow: 'hidden' }}>
                      <img loading="lazy" src={post.cover_image} alt={post.title} style={{ width: '100%', height: '100%', objectFit: 'cover', filter: 'brightness(0.75)' }} />
                    </div>
                  )}
                  <div style={{ padding: '20px 20px 24px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12, flexWrap: 'wrap' }}>
                      {post.category && (
                        <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 10, color: '#00e5ff', background: 'rgba(0,229,255,0.08)', border: '1px solid rgba(0,229,255,0.2)', borderRadius: 2, padding: '3px 8px', letterSpacing: 1 }}>{post.category.toUpperCase()}</span>
                      )}
                      <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 10, color: '#6a6a88', letterSpacing: 0.5 }}>{readTime(post.content)} baca</span>
                    </div>
                    <h3 style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: 17, color: '#f2f2ff', margin: '0 0 10px', lineHeight: 1.35, letterSpacing: '-0.3px' }}>{post.title}</h3>
                    {post.excerpt && <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: '#6a6a88', lineHeight: 1.7, margin: '0 0 16px', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{post.excerpt}</p>}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                      <Calendar size={12} color='#6a6a88' />
                      <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 11, color: '#6a6a88' }}>{formatDate(post.created_at)}</span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
